export default "__VITE_ASSET__pepImeGiWou_5bV6m4snlg__"